/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import AuthProviderEdit from './AuthProviderEdit';
import Loader from '../../../../../../components/ui-elements/loader';
import AuthProviderHistory from './AuthProviderHistory';
import { FaHistory } from 'react-icons/fa';
import { getAllAuthProvider } from '../../../../../../store/reducers/authProvider/authProviderActions';
import { AuthProviderModel } from '../../models/AuthProviderModel';

const AuthProviderList = () => {
    const [selectedAuthProvider, setSelectedAuthProvider] = useState(AuthProviderModel); 
    const [openEditAuthProvider, setOpenEditAuthProvider] = useState(false);
    const [openHistoryAuthProvider, setOpenHistoryAuthProvider] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const authProviders = useSelector(state => state.authProvider.authProviders)
    const handleCloseDialog = () => {
        setOpenEditAuthProvider(false);
        setOpenHistoryAuthProvider(false);
    }
    const fetchAuthProviders = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllAuthProvider()).unwrap()
            setLoading(false)

        } catch (error) {
            setLoading(false)
        }
    }, [dispatch]);
    useEffect(() => {
        fetchAuthProviders()
    }, [fetchAuthProviders])
    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Identity Provider Name" />
                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {authProviders?.length > 0 && authProviders.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.authProviderName} />
                                <StyledTableCell>
                                    {row.authProviderDetails.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.authProviderDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.authProviderDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'} </Typography> : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedAuthProvider(row); setOpenEditAuthProvider(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedAuthProvider(row); setOpenHistoryAuthProvider(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}

            <DialogContainer
                open={openEditAuthProvider}
                handleClose={handleCloseDialog}
            >
                <AuthProviderEdit
                    selectedAuthProvider={selectedAuthProvider}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryAuthProvider}
                handleClose={handleCloseDialog}
            >
                <AuthProviderHistory
                    selectedAuthProvider={selectedAuthProvider}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}


export default AuthProviderList;